module.exports = __webpack_public_path__ + "img/colabora.2576bdc1.png";